"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTransactionRelationsTypes = exports.SourceTypes = exports.IssueTypes = exports.CostBasisUpdatedBy = exports.WalletTypes = exports.TransactionTypes = exports.ProcessTypes = void 0;
exports.ProcessTypes = {
    EMPTY: 'empty',
    ROUTINE: 'routine',
    AMENDMENT: 'amendment',
    NON_ROUTINE: 'non-routine',
    BRIDGE: 'bridge',
};
exports.TransactionTypes = {
    ISSUANCE: 'issuance',
    REALLOCATION: 'reallocation',
    TRANSFER_OK: 'transfer-ok',
    TRANSFER_REJECTED: 'transfer-rejected',
    RECLAIM: 'reclaim',
    DESTROY: 'destroy',
    FREEZE: 'freeze',
    UNFREEZE: 'unfreeze',
    REDEMPTION: 'redemption',
};
exports.WalletTypes = {
    DRS: 'drs',
    BONUS: 'bonus',
    ONCHAIN: 'onchain',
};
exports.CostBasisUpdatedBy = {
    OPERATOR: 'operator',
    INVESTOR: 'investor',
    API: 'api',
};
exports.IssueTypes = {
    PREPRESALE: 'prepresale',
    PRESALE: 'presale',
    MAINSALE: 'mainsale',
    REISSUANCE: 'reissuance',
    OTHER: 'other',
    DRIP: 'drip',
};
exports.SourceTypes = {
    OTHER: 'other',
    IMPORT: 'import',
};
exports.TokenTransactionRelationsTypes = {
    BLOCKCHAIN_TRANSACTION: 'blockchainTransaction',
    TOKEN_ISSUANCE: 'tokenIssuance',
};
//# sourceMappingURL=token-transaction.js.map